<template>
<v-dialog
    v-model="dialog"
    max-width="1250"
    v-if="template != null"
>
    <v-card>
        <v-card-title>{{template.label}}</v-card-title>

        <v-card-text>
            <v-text-field
                label="Label"
                v-model="template.label"
            />

            <v-select
                label="Industries"
                :items="$rc.enumChoices('industry_code', false)"
                v-model="template.industries"
                multiple
            />

            <v-select
                label="State"
                :items="$rc.enumChoices('bulk_message_template_state', false)"
                v-model="template.state"
            />

            <v-select
                label="Types"
                :items="$rc.enumChoices('bulk_message_template_type', true, 'Any Type')"
                v-model="template.types"
                multiple
            />

            <v-select
                label="Message Type (Consent Category)"
                :items="[
                    {'text': 'Informational', 'value': 'informational'},
                    {'text': 'Promotional', 'value': 'promotional'},
                ]"
                v-model="template.consent_category"
            />

            <m-edit-blobs
                label="Image (optional)"
                empty_text="No image"
                v-model="template.blob_ids"
                :process_media="true"
                :externally_visible="true"
                :allow_multiple="false"
                :limit_to_size="460800"
                style="padding-bottom: 7px; margin-bottom: 15px; border-bottom: 1px solid rgb(148,148,148); margin-top: 15px"
                edit_icon="mdi-lead-pencil"
                dialog_title="Bulk Message Template Image"
                dialog_hint="<b>Image limitations:</b>  Images <b>must</b> be 450 Kb or smaller.<br/><br/><b>Image size:  </b>For best results, images should be square or close to square.  The ideal image size is 400 x 400 pixels."
            />

            <m-edit-message-patterns
                v-model="template.message_patterns"
                context="bulk-message"
                :always_mms="false"
            />
        </v-card-text>

        <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn
                text
                @click="onCancel"
            >
            Cancel
            </v-btn>

            <v-btn
                color="primary darken-1"
                text
                @click="onOk"
            >
            Save
            </v-btn>

        </v-card-actions>

    </v-card>
</v-dialog>
</template>

<script>
const _ = require('lodash');
export default {

    data() {
        return {
            dialog: false,
            template: null,
        }
    },

    methods: {

        showDialog(template_id)
        {
            this.$rc.rest({
                'spinner': true,
                'endpoint': 'GET: /api/v1/bulk/templates/:template_id',
            
                'params' : {
                        'template_id': template_id,
                    },
            
                'on_success': (data) => {
                        this.template = data;
                        this.dialog = true;
                    },
            
                'on_error': 'Unable to load template',
            });
        },

        showDialogCreate(stub)
        {
            this.template = _.cloneDeep(stub);
            this.dialog = true;
        },

        onOk()
        {
            this.$rc.rest({
                'spinner': false,
                'endpoint': 'PUT: /api/v1/bulk/templates',
            
                'params' : this.template,
            
                'on_success': (data) => {
                        this.dialog = false;
                        this.$emit('input', this.template);
                    },
            
                'on_error': 'Unable to save template',
            });
        },

        onCancel()
        {
            this.dialog = false;
        },

       
    },
}
</script>

<style lang="scss" scoped>
</style>